import { isValid } from 'date-fns';
import { START_OF_DAY_TIME_VALUES } from '../../../../../../constants';

type NormalizedDateTime = {
  normalizedDateTime: Date;
  shouldResetAllowTime: boolean;
};

export const normalizeDateTime = (
  dateTime: Date,
  hasCorrectValue: boolean,
  hasTime: boolean,
  minValue: Date | null,
  maxValue: Date | null
): NormalizedDateTime => {
  let normalizedDateTime = dateTime;
  if (!hasCorrectValue) {
    if (minValue && normalizedDateTime < minValue) {
      normalizedDateTime = new Date(minValue.getTime());
    } else if (maxValue && normalizedDateTime > maxValue) {
      normalizedDateTime = new Date(maxValue.getTime());
    }
  }
  // Never let an unparseable value reach format() below — it throws on Invalid Date.
  if (!isValid(normalizedDateTime)) {
    normalizedDateTime = new Date();
  }
  const shouldResetAllowTime = !hasTime;
  if (shouldResetAllowTime) {
    normalizedDateTime.setHours(...START_OF_DAY_TIME_VALUES);
  }
  return { normalizedDateTime, shouldResetAllowTime };
};
